import { Component, TemplateRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbOffcanvasConfig, NgbOffcanvas, NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Editor } from 'ngx-editor';
import { ToastrService } from 'ngx-toastr';
import { AffectationService } from '../../../../../core/services/affectation.service';
import { FileService } from '../../../../../core/services/file.service';
import { InqueryService } from '../../../../../core/services/inquery.service';
import { ReponseService } from '../../../../../core/services/reponse.service';
import { GlobalName } from '../../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { NgxSpinnerService } from "ngx-spinner";
import { PersonalService } from '../../../../../core/services/personal.service';
import { CommonModule, Location } from '@angular/common';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';


@Component({
    selector: 'app-inquery-details',
    templateUrl: './inquery-details.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxExtendedPdfViewerModule],
    styleUrls: ['./inquery-details.component.css']
})
export class InqueryDetailsComponent {

  @ViewChild('contentPDF') contentPDF:TemplateRef<any> | undefined
  @ViewChild('contentFiche') contentFiche:TemplateRef<any> | undefined
  pdfSrc = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  loading:any
  data:any
  type:any
  uas:any[]=[]
  ts:any[]=[]
  elements:any[]=[]
  members:any[]=[]
  nature_command:any[]=[]
  pdfViewLoader=false
  user:any
  use_form=1;
  fileInput:any
  editor: Editor | undefined;
  observation = '';
  is_verified=true
  role:any

  constructor(
    private spinnerService:NgxSpinnerService,
    private location:Location,
    private personalService:PersonalService,
    private responseService:ReponseService,
    private affectationService:AffectationService,
    private router:Router,
    private activatedRoute:ActivatedRoute,
    private toastrService:ToastrService,
    private cmService:InqueryService,
    private fileService:FileService,
    private spinner: NgxSpinnerService,
    private lsService:LocalStorageService,
    configCanvas: NgbOffcanvasConfig, 
    private offcanvasService: NgbOffcanvas,
    config: NgbModalConfig,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;


     configCanvas.position = 'end';
     configCanvas.backdropClass = 'bg-info';
     configCanvas.keyboard = false;
     }


  ngOnInit(): void {
    this.type=this.activatedRoute.snapshot.paramMap.get('code') ?? '';
    this.nature_command=this.lsService.get(GlobalName.features).nature_command

    if(this.type!= undefined){
      this.user=this.lsService.get(GlobalName.userName)
      this.role=this.user.roles[0].name.toLowerCase()
      console.log('user', this.user)
      this.getAll()
      this.getOne()
      this.editor = new Editor();
     }else{
      this.router.navigate(['/admin/dashboard'])
  
     }
  }

  getAll(){
    this.personalService.getMembers().subscribe((res:any)=>{
      this.uas=res.data
    },
    (err:any)=>{
      AppErrorShow.showError("Gestion des préoccupations",err)

    })
  }
 

  getFile(code:any,folder:any,filename:any,css='details-panel'){
    this.pdfViewLoader=true
    this.spinnerService.show()
    this.fileService.get({
      folder:folder,
      code:code,
      filename:filename
    }).subscribe((res:any)=>{
      this.spinner.hide()
      this.getOne()
      this.pdfViewLoader=false
      this.pdfSrc=res[0]
      this.offcanvasService.open(this.contentPDF,{  panelClass: css, position: 'end'  });

    },
    (err:any)=>{
this.spinnerService.hide()
AppErrorShow.showError("Gestion des préoccupations",err)

    })
  }
  getOne(){
    this.spinner.show();
    this.cmService.get(this.type).subscribe((res:any)=>{
       this.spinner.hide();
      this.data=res.data
      this.prepareContent()
    },
    (err:any)=>{
      this.spinner.hide();
      AppErrorShow.showError("Gestion des préoccupations",err)

    })
  }
 



  open2(content:any){
    this.pdfViewLoader=true
    this.fileService.get({
      code:this.data.code,
      filename:"Contracts Markets/"+this.data.folder_filename
    }).subscribe((res:any)=>{
      this.pdfViewLoader=false
      this.pdfSrc=res[0]
      this.offcanvasService.open(content,{  panelClass: 'details-panel', position: 'end'  });
    },
    (err:any)=>{
      this.pdfViewLoader=false
      AppErrorShow.showError("Gestion des préoccupations",err)

    })
  
  }

  decide(){
    if(this.data?.user_response){
      this.elements=[]
      let userElements=JSON.parse(this.data?.user_response?.observation)
      userElements.forEach((el:any,index:any) => {
        this.elements.push({
          name:el.name,
          response:el.response,
          observation:el.observation
        })
      });
      this.getFile(this.data?.code,'responses',this.data?.user_response.filename,'details-panel2')
    }else{
      this.getFile(this.data?.code,"Contracts Markets",this.data.folder_filename,'details-panel2')
      //this.offcanvasService.open(this.contentPDF,{  panelClass: 'details-panel2', position: 'end'  });
    }
    this.offcanvasService.open(this.contentFiche,{panelClass: 'details-panel2',position: 'start'  })
  }
  open(content:any){
    this.modalService.open(content,{size:'lg'})
  }
  openFinished(content:any){
    let checkNotchecked= this.elements.filter((el:any)=>el.response==null)
    if(checkNotchecked.length>0){
      this.elements.forEach((el:any) => {
        if (el.response==null) {
          el.alert=true
        }
      });
      this.toastrService.warning('Veuillez remplir toute la fiche svp')

      return ;
    }
    this.modalService.open(content,{size:'lg'})
  }

  changeAlert(ev:any,index:any){

    if (this.elements[index].alert) {
      this.elements[index].alert=false
    }
  }

  openCanvas(content:any, r?:any){
    this.offcanvasService.open(content,{  panelClass: 'details-panel', position: 'end'  });
  }

  store(value:any){
    console.log(value)
    this.loading=true
    this.affectationService.store({
      is_last:1,
      instruction:value.instruction,
      delay:value.delay,
      up_id:this.user?.id,
      down_id:value.down,
      sens:-1,
      inquery_id:this.data.id
    }).subscribe((res:any)=>{
      this.loading=false
        this.modalService.dismissAll()
        this.toastrService.success('Votre élément de réponse transmis avec succès')
        this.router.navigate(['admin/inqueries/index/own'])
    },
    (err:any)=>{
      this.loading=false
      AppErrorShow.showError("Gestion des préoccupations",err)

    })

  }
  store2(value:any){
    console.log(value)
    this.affectationService.store({
      is_last:1,
      instruction:value.instruction,
      delay:value.delay,
      up_id:this.user?.id,
      down_id:value.down,
      sens:0,
      inquery_id:this.data.id
    }).subscribe((res:any)=>{
        this.modalService.dismissAll()
        this.toastrService.success('Votre élément de réponse transmis avec succès')
        this.router.navigate(['admin/inqueries/index/own'])
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des préoccupations",err)

    })

  }
  storeResponse(value:any,form:any,id?:any){
    let formData=new FormData()
   
    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        const element = value[key];
        formData.append(key,element)
      }
    }
    formData.append('inquery_id',this.data?.id)
    formData.append('affectation_id',this.data?.affectation?.id??id)
    if(this.fileInput==undefined){
      formData.append('filename',this.fileInput)
    }
    this.loading=true
    this.responseService.store(formData).subscribe((res:any)=>{
      this.loading=false
      this.toastrService.success(res.message)
      form.resetForm()
      this.getOne()
    },
    (err:any)=>{
      this.loading=false
      AppErrorShow.showError("Gestion des préoccupations",err)

    })

  }
  
  returnResponse(value:any){
    let formData=new FormData()
    if(!value.use_form){
      if(this.fileInput==undefined){
        this.toastrService.warning('Le fichier est requis');
        return ;
      }else{
        formData.append('file',this.fileInput)
      }
    }
    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        const element = value[key];
        formData.append(key,element)
      }
    }
    formData.append('inquery_id',this.data.id)
    this.responseService.store(formData).subscribe((res:any)=>{
        this.modalService.dismissAll()
        this.toastrService.success('Votre élément de réponse a été sauvegardé avec succès')
        this.getFile(res.data?.code,res.data?.folder,res.data?.filename)
       // this.router.navigate(['admin/espace-dcetp/acts/new'])
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des préoccupations",err)
    })

  }

  upload(event:any){
    if (event.target.files.length!=0) {
      this.fileInput=event.target.files[0]
    }
  }

  updateResponse(value:any){
    this.modalService.dismissAll()
    let formData=new FormData()
    if(!value.use_form){
      if(this.fileInput==undefined){
        this.toastrService.warning('Le fichier est requis');
        return ;
      }else{
        formData.append('file',this.fileInput)
      }
    }
    let checkFileTreatment=this.elements.filter((el:any)=> el.response==null)
    if(checkFileTreatment.length!=0){
      this.toastrService.warning('Le fichier \'est pas totalement traité.');
        return ;
    }
    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        const element = value[key];
        formData.append(key,element)
      }
    }
    formData.append('inquery_id',this.data.id)

    this.responseService.update(this.data.user_response.id,formData).subscribe((res:any)=>{
        this.modalService.dismissAll()
        let closePDFBtn:HTMLElement = document.getElementById('closePDFBtn') as HTMLElement;
        let closeFicheBtn:HTMLElement = document.getElementById('closeFicheBtn') as HTMLElement;

        closePDFBtn?.click()
        closeFicheBtn?.click()

        this.toastrService.success('Votre élément de réponse a été sauvegardé avec succès')
        this.getFile(res.data?.code,res.data?.folder,res.data?.filename)
       // this.router.navigate(['admin/espace-dcetp/acts/new'])
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des préoccupations",err)
    })
  }
  transmit(){
    this.loading=true
    this.affectationService.store({
      is_last:1,
      instruction:null,
      delay:null,
      up:this.user?.id,
      down:this.user?.officer?.cop?.ua?.parent_id,
      sens:1,
      space:this.user?.space,
      prestation:'cm',
      inquery_id:this.data.id
    }).subscribe((res:any)=>{
      this.loading=false
        this.modalService.dismissAll()
        this.offcanvasService.dismiss()
        this.toastrService.success('Votre élément de réponse transmis avec succès')
        this.router.navigate(['/admin/espace-dcetp/contracts/pending'])
    },
    (err:any)=>{
      this.loading=false
      AppErrorShow.showError("Gestion des préoccupations",err)

    })
  }

  getStatusColor(){
    let color=""
    switch (this.data?.status) {
      case 0:
        color="bg-secondary"
        break;
      case 1:
        color="bg-warning"
        break;
    
      default:
        break;
    }

    return color;
  }
  getStatusText(){
    let text=""
    switch (this.data?.status) {
      case 0:
          text= "Nouveau"
        break;
    
      case 1:
        text= "A traiter"
        break;
    
      default:
        break;
    }
    return text;
  }

  reload(){
    console.log(this.data?.responses[0])
    if (this.data?.responses[0].use_form) {
        this.elements=JSON.parse(this.data?.responses[0].observation)
      
    }
    
    
  }


  finished(value:any){
    let formData= new FormData()
    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        const element = value[key];
        formData.append(key,element)
      }
    }

    if (this.fileInput!=undefined) {
        formData.append("filename",this.fileInput)
    }
    formData.append("id",this.data?.id)

    this.loading=true
    this.cmService.finished(formData).subscribe((res:any)=>{
      this.loading=false

      this.toastrService.success('Préoccupation clotûrée avec succès')
      this.location.back()
    },
    (err:any)=>{
      this.loading=false
      AppErrorShow.showError("Gestion des préoccupations",err)

    })
  }

  ngOnDestroy(): void {
    this.editor?.destroy();
  }

  prepareContent(){
    this.observation=`
    <p>Le présent projet de contrat soumis par la Personne Responsable des Marchés Publics de ${this.data?.name} est d’un montant global de ${this.data?.amount} francs CFA et se présente comme suit : 
    </p><p><strong>Nature de la prestation :</strong> ${this.data?.nature_command}</p>
    <p><strong>Attributaire :</strong> ${this.data?.owner}</p>
    <p><strong>Mode de passation :</strong> ${this.data?.mp?.name}</p>
    <p><strong>Source de financement :</strong> ${this.data?.fs?.name}</p>
    <p><strong>Structures bénéficiaires :</strong> ${this.data?.beneficiary?.name}</p>
    <p><strong>Avis de la DNCMP :</strong> </p>
    <p><strong>Références du PV :</strong> ${this.data?.ref_folder}</p>
    `
  }
}
